@use '@fukuri-admins/ui/layout' as *;

.root {
  width: fit-content;
  background-color: background('Primary');
  border-radius: borderRadius('lg');
  border: 1px solid border('Secondary');
  padding: spacing('12');
  @include elevation('2');

  [data-slot="card-content"] & {
    background-color: transparent;
  }

  [data-slot="popover-content"] & {
    background-color: transparent;
  }
}

.months {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: spacing('12');
}

.month {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: spacing('16');
}

.button_previous {
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  height: spacing('32');
  width: spacing('32');
  background-color: transparent;

  > svg {
    height: spacing('16');
    width: spacing('16');
    color: text('High');
  }
}
.button_next {
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  height: spacing('32');
  width: spacing('32');
  background-color: transparent;

  > svg {
    height: spacing('16');
    width: spacing('16');
    color: text('High');
  }
}

.month_caption {
  display: flex;
  height: spacing('32');
  justify-content: center;
  align-items: center;

  @include typography('Jp/14_W3');
}

.month_grid,
.weeks {
  display: flex;
  flex-direction: column;
  gap: spacing('8');
}

.weekday {
  width: spacing('32');
  height: 21px;
  padding: 0;
  color: text('Low');
  @include typography('Jp/12_W3');
  text-align: center;
}

.day {
  padding: 0;
  color: text('High');
  @include typography('Jp/12_W3');
}

.today {
  button {
    background: background('Overlay_Bl_5');
  }
}

.outside {
  button {
    color: text('Low');
    &:not(:focus):hover {
      color: text('High');
      background: background('Overlay_Bl_5');
    }
  }
}

.selected {
  button {
    background-color: background('Gray_Darken');
    color: text('White');
    &:not(:focus):hover {
      color: text('High');
      background: background('Overlay_Bl_5');
    }
  }
}

.focused {
  button {
    background-color: background('Gray_Darken');
    color: text('White');
    box-shadow: 0 0 0 3px border('Focus');
  }
}

.day_button {
  width: spacing('32');
  height: spacing('32');
  padding: 0;
  border-radius: borderRadius('lg');
  background-color: transparent;

  &:not(:focus):hover {
    background: background('Overlay_Bl_5');
  }
}

.disabled {
  .day_button {
    cursor: not-allowed;
    color: text('Disabled');

    &:not(:focus):hover {
      background-color: transparent;
      color: text('Disabled');
    }
  }

  &.outside {
    button {
      &:not(:focus):hover {
        color: text('Disabled');
      }
    }
  }
}
